<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-04-23 11:47:52
 * @LastEditors: 刘明魁
 * @LastEditTime: 2023-08-12 09:43:48
-->
<template>
	<div class="page page_xiaofei">
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
			<div class="list">
				<div class="item" v-for="(item,index) in dataList" :key="index">
					<div class="item_r">
						<div class="item_nr">
							<div class="title slh_s">{{ item.pay_order_num }}</div>
							<div class="time">{{ item.created_at }}</div>
						</div>
						<div class="item-nr-r">
							<!-- 1收入 0支出 -->
							<div class="price"><span class="tag_cash">{{ item.type == 1 ?'+':'-' }}¥</span>{{ item.score }}</div>
							<!-- 0商城1云商城3新积分 -->
							<div class="order-source">{{ item.source == 0 ? '商城单' : item.source == 1 ? '云商城单' : item.source == 1 ? '新积分单' : '' }}</div>
						</div>
					</div>
				</div>
			</div>
		</van-list>
	</div>
</template>
<script>
import Vue from 'vue';
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
	data(){
		return{
			token: null,
			page: 1,
			size: 10,
			dataList: [],
			loading: false,
			finished: false
		}
	},
	created(){
		if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
			var params = {
				'data': {
					'naviTitle': '积分记录'
				}
			}
			this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

			})
			var memberParams = {
				'data': {}
			}
			this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
				console.log('sdjy://member/memberInfo')
				console.log(data)
				if (data.code == 200) {
					this.token = data.result.token
					this.getData()
				}
			})
			//注册方法，客户端重新进入页面刷新数据
			this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
				this.getData()
				responseCallback({})
			})
		} else {
			this.token = this.$store.getters.token
			this.getData()
		}
	},
	methods: {
		getData(){
			let params = {
				token: this.token,
				page: this.page,
				size: this.size
			};
			this.$api.my.pointlist(params).then(res=>{
				if(res.code == 200){
					let list = res.result;
					if(list && list.length){
						for(let i in list){
							this.dataList.push(list[i])
						};
						if(list.length < this.size){
							this.finished = true;
						}else{
							this.page++;
							this.loading = false;
						}
					}else{
						this.finished = true;
					}
				}
			})
		}
	},
}
</script>
<style scoped>
	.page_xiaofei .item_r{
		width: 100%;
	}
	.order-source{
		font-size: 0.32rem;
    	color: rgba(154, 154, 154, 1);
	}
</style>